import { createStyles } from '@mantine/core';

var useStyles = createStyles((theme) => ({
  yearLevel: {},
  calendarHeader: {
    marginBottom: theme.spacing.xs
  }
}));

export default useStyles;
//# sourceMappingURL=YearLevel.styles.js.map
